/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Only_Networks_With_History_DescriptionInputs */

const fr_settings_only_networks_with_history_description = /** @type {(inputs: Settings_Only_Networks_With_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des réseaux à afficher sur la page de sélection de la page Données.`)
};

const en_settings_only_networks_with_history_description = /** @type {(inputs: Settings_Only_Networks_With_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Networks to show on the Data selection page.`)
};

/**
* | output |
* | --- |
* | "Networks to show on the Data selection page." |
*
* @param {Settings_Only_Networks_With_History_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_only_networks_with_history_description = /** @type {((inputs?: Settings_Only_Networks_With_History_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Only_Networks_With_History_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_only_networks_with_history_description(inputs)
	return en_settings_only_networks_with_history_description(inputs)
});